export const TicketType = {
  NORMAL: "NORMAL",
  INCIDENT: "INCIDENT",
  JOB: "JOB",
}

export const TicketTypeLabel = {
  NORMAL: "Normal",
  INCIDENT: "Incident",
  JOB: "Job",
}
